import Swal from 'sweetalert2';
import router from '@/router'; // adjust path if needed
import Cookies from 'js-cookie';

const INACTIVITY_LIMIT = 5 * 60 * 1000; // 5 minutes
const WARNING_TIME = 20 * 1000; // 20 seconds

let inactivityTimer;
let warningTimer;

function resetTimers() {
  clearTimeout(inactivityTimer);
  clearTimeout(warningTimer);

  if (!isUserLoggedIn()) {
    return;
  }

  inactivityTimer = setTimeout(() => {
    showWarning();
  }, INACTIVITY_LIMIT);
}

function logout() {
  Cookies.remove('auth_token');
  router.push({ name: 'Login' });
}

function showWarning() {
    if (!isUserLoggedIn()) {
        return;
    }
    let timerInterval;
    let timeLeft = WARNING_TIME / 1000; // 20 seconds in seconds
  
    Swal.fire({
      title: 'Are you still there?',
      html: `You will be logged out in <b>${timeLeft}</b> seconds due to inactivity.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: "I'm still here",
      cancelButtonText: 'Logout now',
      customClass: {
        confirmButton: 'swal2-confirm-btn',
        cancelButton: 'swal2-cancel-btn'
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      timer: WARNING_TIME,
      timerProgressBar: true,
      didOpen: () => {
        const b = Swal.getHtmlContainer().querySelector('b');
  
        timerInterval = setInterval(() => {
          timeLeft -= 1;
          if (b) b.textContent = timeLeft;
        }, 1000);
      },
      willClose: () => {
        clearInterval(timerInterval);
        // If timer runs out without user interaction
        if (Swal.getTimerLeft() === 0) {
          logout();
        }
      }
    }).then((result) => {
      clearInterval(timerInterval);
      if (result.isConfirmed) {
        resetTimers();
      } else {
        logout();
      }
    });
  }
  

function setupInactivityTimer() {
  const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];

  const activityHandler = () => {
    resetTimers();
  };

  events.forEach(event => {
    window.addEventListener(event, activityHandler);
  });

  resetTimers();
}

function isUserLoggedIn() {
    return !!Cookies.get('auth_token');
}

export default {
  setupInactivityTimer,
  logout,
};
